import React, { Component } from "react";

class Ribbon extends Component {
  constructor(props) {
    super(props);

    let color = props.color ? props.color : "rgba(0,0,0,0.5)";
    let selectedcolor = props.selectedcolor
      ? props.selectedcolor
      : "rgba(0,0,0,0)";

    this.state = {
      width: props.width ? props.width : 25,
      height: props.width ? props.width : 25,
      color: props.selected ? selectedcolor : color,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        color: nextProps.selected ? nextProps.selectedcolor : nextProps.color,
      });
    }
  }

  render() {
    return (
      <span className={this.props.className}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={`${this.props.width || this.state.width}px`}
          height={`${this.props.height * 1 || this.state.height * 1}px`}
          viewBox="0 0 750 750"
          style={{
            enableBackground: "new 0 0 750 750",
          }}
        >
          <g>
            <title>Layer 1</title>
            <path
              id="svg_3"
              d="m489.760007,12.979993c-2.32,1.74 -8.12,8.12 -13.14,14.11c-18.36,22.61 -30.73,25.13 -57.400001,11.02c-9.08,-4.83 -18.94,-8.7 -21.65,-8.7c-8.7,0 -17.2,10.44 -21.07,26.09c-4.25,17.39 -9.28,25.32 -19.13,30.15c-7.15,3.67 -9.86,4.06 -29.77,2.71l-21.84,-1.35l-5.99,5.99l-5.99,5.99l1.35,21.84c1.35,19.91 0.97,22.61 -2.71,29.77c-4.83,9.66 -12.18,14.3 -30.92,19.91c-16.24,4.83 -25.32,11.98 -25.32,20.29c0,4.83 1.35,8.12 12.37,28.8c5.8,11.21 6.57,23.39 1.74,33.44c-1.74,3.67 -9.08,11.4 -16.24,17.2c-14.5,11.6 -17.2,15.27 -17.2,23.39c0.19,8.12 3.67,12.95 16.43,23.39c23.58,18.94 25.71,29.77 11.6,57.600001c-9.47,18.55 -10.05,21.45 -5.99,29.57c3.09,5.6 11.02,9.66 28.61,14.69c13.14,3.48 23.58,11.98 26.67,21.45c1.55,4.64 1.93,13.14 0.97,25.71c-1.16,15.46 -0.77,20.1 1.74,24.93c4.45,8.5 14.11,10.82 32.08,7.92c28.22,-4.64 40.200001,4.45 49.290001,37.690001c1.74,6.18 5.22,13.34 7.92,16.04c6.96,6.96 19.13,5.41 34.600001,-3.87c14.11,-8.7 24.55,-10.63 34.790001,-6.19c9.47,3.87 12.95,6.96 22.61,19.91c4.25,5.61 10.44,11.6 14.11,13.34c11.21,5.41 17.98,1.54 35.560001,-20.68c8.5,-10.63 20.87,-16.23 31.89,-14.69c4.44,0.77 13.33,4.45 19.52,8.31c15.46,9.28 27.64,10.82 34.600001,3.87c2.71,-2.71 6.18,-9.86 7.92,-16.04c9.08,-33.24 21.07,-42.330001 49.290001,-37.690001c17.98,2.9 27.64,0.58 32.08,-7.92c2.51,-4.83 2.9,-9.47 1.74,-24.93c-0.97,-12.56 -0.58,-21.07 0.97,-25.71c3.09,-9.47 13.53,-17.98 26.67,-21.45c17.59,-5.03 25.51,-9.08 28.6,-14.69c4.06,-8.12 3.48,-11.6 -5.99,-29.38c-14.3,-27.25 -12.18,-38.850001 11.6,-57.790001c12.75,-10.44 16.24,-15.27 16.43,-23.39c0,-8.12 -2.71,-11.79 -17.2,-23.39c-14.69,-11.79 -19.52,-19.91 -19.52,-32.47c0,-8.12 1.35,-11.4 12.95,-32.86c1.55,-2.9 3.29,-8.31 3.87,-11.98c1.54,-9.86 -6.19,-17.01 -24.74,-22.42c-17.98,-5.22 -27.25,-11.21 -31.7,-20.29c-2.9,-6.19 -3.09,-10.44 -1.93,-29.19l1.35,-22.03l-5.99,-5.99l-5.99,-5.99l-21.84,1.35c-19.91,1.35 -22.61,0.97 -29.77,-2.71c-9.86,-5.03 -14.69,-12.56 -19.71,-31.12c-4.25,-16.04 -11.79,-25.13 -20.68,-25.13c-4.64,0 -7.93,1.35 -28.61,12.37c-17.97,9.47 -36.720001,4.83 -48.510001,-12.37c-12.38,-17.78 -24.95,-23.58 -35.380001,-16.43zm57.590001,89.690001c19.71,5.03 48.130001,18.17 64.940001,30.15c37.300001,26.67 65.330001,68.040001 77.310001,114.040002c4.45,16.62 5.03,23.39 5.22,48.320001c0,24.93 -0.77,31.5 -5.02,47.550001c-13.53,51.030001 -42.130001,92.000001 -83.500001,118.870002c-32.67,21.26 -67.650001,31.7 -106.300002,31.7c-92.390001,0 -170.670003,-64.170001 -191.730003,-156.940002c-4.83,-21.45 -4.25,-63.400001 0.97,-85.240001c14.3,-58.560001 50.640001,-105.920002 100.890002,-131.620002c21.26,-10.82 29.96,-13.92 51.220001,-18.55c22.99,-5.05 61.840001,-4.28 86.000001,1.72z"
              fill={this.state.color}
            />
            <path
              stroke="#f1c232"
              strokeOpacity="0"
              id="svg_4"
              d="m470.805991,136.489994c-18.17,3.48 -25.9,6.19 -42.330001,14.11c-41.750001,20.68 -71.710001,57.600001 -84.270001,103.990002c-5.99,21.84 -5.99,59.340001 0,81.180001c22.23,82.330001 101.280002,133.550002 182.260003,118.090002c61.080001,-11.79 109.400002,-57.210001 125.440002,-118.100002c4.83,-18.55 5.8,-55.470001 1.93,-73.450001c-10.82,-49.290001 -42.130001,-89.680001 -86.980001,-112.100002c-27.63,-13.72 -66.670001,-19.33 -96.050001,-13.72z"
              fill={this.state.color}
            />
            <path
              id="svg_5"
              d="m323.340005,536.19c-10.24,32.86 -110.360002,382.700006 -110.360002,385.980006c0,5.99 5.41,14.88 11.02,17.78c5.02,2.71 -0.19,4.06 62.820001,-16.43l43.870001,-14.3l37.110001,40.390001c40.010001,43.680001 40.780001,44.260001 53.150001,36.720001c3.29,-1.93 6.96,-6.18 8.12,-9.08c1.16,-3.09 17.01,-57.790001 35.180001,-121.570002c18.17,-63.780001 33.630001,-117.710002 34.600001,-119.830002l1.55,-3.87l1.16,3.87c0.58,2.13 16.04,56.050001 34.210001,119.830002c18.17,63.780001 34.020001,118.480002 35.180001,121.570002c1.16,2.9 4.83,7.15 8.12,9.08c12.37,7.54 13.14,6.96 53.150001,-36.720001l36.920001,-40.390001l49.870001,16.23c27.25,8.89 51.030001,16.24 52.770001,16.24c5.03,0 15.27,-12.76 15.27,-18.94c0,-5.03 -110.940002,-390.230006 -112.880002,-392.170006c-1.93,-1.93 -10.63,1.35 -16.62,6.38c-7.34,6.38 -12.95,16.82 -15.65,30.15c-4.64,21.84 -14.5,32.08 -28.41,29.76c-3.67,-0.58 -12.56,-4.64 -19.91,-8.89c-7.35,-4.44 -18.17,-8.89 -23.78,-10.05c-9.66,-2.13 -11.02,-1.93 -21.26,3.09c-8.31,4.06 -13.14,8.31 -20.49,17.98c-21.65,28.6 -34.400001,28.99 -54.510001,1.93c-20.1,-26.87 -37.880001,-30.35 -67.450001,-12.76c-7.15,4.25 -15.85,8.12 -19.52,8.7c-13.92,2.32 -23.39,-7.54 -28.61,-30.15c-4.06,-17.78 -10.82,-28.41 -21.65,-34.020001c-7.94,-4.04 -10.65,-3.27 -12.97,3.49z"
              fill={this.state.color}
            />
          </g>
        </svg>
        {this.props.label && (
          <span
            style={{
              color: this.state.color,
              top: 1,
            }}
            className="label"
          >
            {this.props.label}
          </span>
        )}
      </span>
    );
  }
}

export default Ribbon;
